import {HttpInterceptorFn} from '@angular/common/http';

// Запросы на префикс /api (прокси ng serve → бэкенд): SPA fallback не должен подменять их на index.html
// из‑за Accept со звёздочкой (типичный XHR).
export const apiJsonAcceptInterceptor: HttpInterceptorFn = (req, next) => {
  const path = requestPath(req.url);
  if (!path.startsWith('/api')) {
    return next(req);
  }
  return next(req.clone({setHeaders: {Accept: 'application/json'}}));
};

function requestPath(url: string): string {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      return new URL(url).pathname;
    } catch {
      return url.split('?')[0];
    }
  }
  const q = url.indexOf('?');
  return q >= 0 ? url.slice(0, q) : url;
}
